import router from '@/router'

interface Platform {
  profile: string,
  platform: string,
  platform_name: string,
  id_platform: number
}

interface User {
  id_user: number,
  email: string,
  name: string,
  status_user: string,
  platform_list: Platform[],
  profile: string,
  platform: string,
  saas: number,
  platform_name: string,
  id_platform: number,
  platform_name_pabx: string,
  id_zapguru: number,
  iat: number,
  exp: number
}

const getters = {
  user (): User {
    return router.app.$auth.user()
  },

  userId (state, getters): string {
    return getters.user.id_user
  },

  userEmail (state, getters): string {
    return getters.user.email
  },

  userFullName (state, getters): string {
    return getters.user.name
  },

  userRole (state, getters): string {
    return getters.user.profile
  },

  platformId (state, getters): string {
    return getters.user.id_platform
  },

  platformName (state, getters): string {
    return getters.user.platform
  },

  platformSlug (state, getters): string {
    return getters.user.platform_name
  },

  platformColorPrimary (state, getters, rootState): string {
    const { platforms } = rootState.base
    const { platformId } = getters

    return platforms.find(platform => platform.id === platformId)?.colorPrimary
  },

  routeRoles: (state) => (routePath: string): string[] => {
    return state.roles
      .filter(item => item.allowedRoutes.includes(routePath) === true)
      .map(item => item.role)
  },

  allowedFeature: (state, getters) => (feature: string): boolean => {
    const { userRole } = getters
    const featureFound = state.features.find(item => item.feature === feature)

    return Boolean(featureFound?.allowedRoles.includes(userRole))
  }
}

export default getters
